// @flow

import PointLayer12 from './PointLayer12';

class PointLayer12WithSplices extends PointLayer12 {
    splices(id: string, query: Object) {
        return this.client._request(`${this._getObjectPath(id)}`, 'GET', query)
            .then((response) => response.data);
    }
}

export default PointLayer12WithSplices;
